import { useGetAnalysisSaveActionType } from '@modules/analysis/hooks/useGetAnalysisSaveActionType';
import { useSaveAnalysis } from '@modules/analysis/hooks/useSaveAnalysis';
import { useAnalysisStore } from '@modules/analysis/store/analysisStore';
import { AnalysisActionType } from '@modules/analysis/types';
import { CanAccess } from '@modules/common/components/CanAccess';
import {
  useGetQuantifyChartEQLProps,
  useGetQuantifyCompareQuery,
  useGetQuantifyQueryMetadata,
} from '@modules/quantify/hooks';
import { useQuantifyStore } from '@modules/quantify/store/quantifyStore';
import {
  AnalysisUseCase,
  PermissionOperation,
  PermissionResource,
} from 'generated/graphql';
import { useState } from 'react';
import { SaveAsQuantifyAction } from './SaveAsQuantifyAction';
import { SaveQuantifyAction } from './SaveQuantifyAction';
import { UpdateQuantifyAction } from './UpdateQuantifyAction';

export const QuantifySaveActions = () => {
  const [shouldSaveDashboardFilters, setShouldSaveDashboardFilters] =
    useState(false);

  const actionType = useGetAnalysisSaveActionType();
  const queryMetadata = useGetQuantifyQueryMetadata();
  const quantifyEQLProps = useGetQuantifyChartEQLProps();
  const quantifyMetadata = useAnalysisStore(
    ({ metadataV2 }) => metadataV2?.quantify,
  );

  const groupByLabel = useQuantifyStore(
    ({ query }) => query.groupByField?.displayName,
  );
  const shouldShowAnomalies = useQuantifyStore(
    ({ query }) => query.shouldShowAnomalies,
  );
  const compareQuery = useGetQuantifyCompareQuery();
  const useCase = compareQuery
    ? AnalysisUseCase.Compare
    : AnalysisUseCase.Default;

  const { onSaveAnalysis } = useSaveAnalysis({
    eqlProps: quantifyEQLProps,
    metadata: queryMetadata,
    metadataV2: quantifyMetadata
      ? {
          quantify: quantifyMetadata,
        }
      : undefined,
    shouldRedirect: false,
    eventProps: {
      quantifyQueryOptions: {
        showMeLabel: groupByLabel,
        shouldShowAnomalies,
      },
    },
    useCase,
  });

  return (
    <CanAccess
      resource={PermissionResource.Artefact}
      operation={PermissionOperation.Write}
    >
      <>
        {actionType === AnalysisActionType.SAVE && <SaveQuantifyAction />}
        {actionType === AnalysisActionType.SAVE_UPDATE && (
          <UpdateQuantifyAction
            onAnalysisCreate={onSaveAnalysis}
            shouldSaveDashboardFilters={shouldSaveDashboardFilters}
            setShouldSaveDashboardFilters={setShouldSaveDashboardFilters}
          />
        )}
        {actionType === AnalysisActionType.SAVE_AS && (
          <SaveAsQuantifyAction
            onAnalysisCreate={onSaveAnalysis}
            shouldSaveDashboardFilters={shouldSaveDashboardFilters}
            setShouldSaveDashboardFilters={setShouldSaveDashboardFilters}
          />
        )}
      </>
    </CanAccess>
  );
};
